<template>
  <div id="app">
    <layout-header></layout-header>
    <layout-body></layout-body>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/layout-header'
import layoutBody from "@/components/layout/layout-body";
import layoutFooter from "@/components/layout/layout-footer";

export default {
  name: "app",
  components: {
    layoutBody,
    layoutFooter,
    layoutHeader
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
</style>
